import { render, staticRenderFns } from "./OpenAccountModal.vue?vue&type=template&id=0e2ceac2&scoped=true"
import script from "./OpenAccountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenAccountModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OpenAccountModal.vue?vue&type=style&index=0&id=0e2ceac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2ceac2",
  null
  
)

export default component.exports